<template>
  <div>
    <div class="content-title">
      <span style="font-size: 20px; margin-right: 20px;">账号列表</span>
      <el-button size="medium" type="primary" @click="addAccount">新增账号</el-button>
    </div>
    <div class="content-table">
      <el-table :data="accounts" size='medium' @row-click="fetchAccountDetail" tooltip-effect="light" highlight-current-row>
        <el-table-column prop="account" label="账号" align="left"></el-table-column>
        <el-table-column prop="providerName" label="公司"></el-table-column>
        <el-table-column prop="platformName" label="平台" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column label="转账权限" align="center">
          <template slot-scope="scope"><span>{{ scope.row.payRight | parseRight }}</span></template>
        </el-table-column>
        <el-table-column label="审核权限" align="center">
          <template slot-scope="scope"><span>{{ scope.row.checkRight | parseRight }}</span></template>
        </el-table-column>
        <el-table-column label="app 平台登录权限" align="center">
          <template slot-scope="scope"><span>{{ scope.row.appLoginRight | parseRight }}</span></template>
        </el-table-column>
        <el-table-column label="管理员" align="center">
          <template slot-scope="scope"><span>{{ scope.row.isManager | parseRight }}</span></template>
        </el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
// import { Loading } from 'element-ui';
// import { parseTime } from '@/utils';

export default {
  name: 'accounts',
  data() {
    return {
      accounts: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.fetchAccounts();
  },
  filters: {
    parseRight(right) {
      return right === 1 ? '是' : '否';
    },
  },
  methods: {
    fetchAccounts() {
      this.accounts = [];
      api.fetchAccounts({
        params: {
          params: {
            index: this.currentPage - 1,
            size: this.pageSize,
          },
        },
      }).then((res) => {
        this.accounts = [];
        this.total = 0;
        if (!res) {
          return;
        }
        this.accounts = res.data;
        this.total = res.count;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchAccounts();
    },
    addAccount() {
      this.$router.push({ path: 'addaccount' });
    },
    fetchAccountDetail(row) {
      const params = {
        accountId: row.accountId,
      };
      this.$router.push({ path: 'basicinfo', query: params });
    },
  },
};
</script>

<style lang="less" scoped>

/*
@media screen and (max-width: 1200px) {
  .app-main {
    width: 100%;
  }
}
@media screen and (min-width: 1200px) {
  .app-main {
    width: 1200px;
  }
}
*/

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-tool {
  padding: 27px 17px 20px 17px;
  border: 1px solid #ebeef5;
  background: #fff;
  font-size: 14px;
  color: #606266;
  overflow: hidden;
  margin: 40px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/accounts.vue